import React, { useState } from 'react';

const faqData = [
  { q: 'Are you an HMO Company?', a: 'FSL HMO is not an HMO company. We partner with HMO companies to co-create and provide embedded healthcare solutions for businesses through our open API and infrastructure.' },
  { q: 'How will I handle claims?', a: 'Our platform provides automated claims processing with real-time tracking and instant approvals for eligible claims.' },
  { q: 'Do I need to have an online platform?', a: 'No, we support both online and offline integration options to suit your business needs.' },
  { q: 'Do I need a license?', a: 'No license is required. We handle all regulatory compliance on behalf of our partners.' },
];

function FAQ() {
  const [activeFaq, setActiveFaq] = useState(0);

  return (
    <section className="medolia-faq-sec pt-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-8 order-2 order-xl-1">
            <div className="medolia-image-box">
              <div className="medolia-image mb-30" data-aos="fade-up" data-aos-duration="1000">
                <img src="/assets/images/home-one/hero/bac3.png" alt="" />
              </div>
              
            </div>
          </div>
          <div className="col-xl-7 col-lg-8 order-1 order-xl-2">
            <div className="medolia-content-box mb-5 mb-xl-0">
              <div className="section-title mb-50" data-aos="fade-up" data-aos-duration="1000">
                <span className="sub-title">FAQ's</span>
                <h2 className="mb-20">HMO FAQs – Everything You Need to Know</h2>
                <p>Get answers to common HMO questions, healthcare services & integration for informed decision-making.</p>
              </div>
              <div className="accordion" id="accordionOne">
                {faqData.map((item, index) => (
                  <div className="accordion-card mb-10" key={index} data-aos="fade-up" data-aos-duration={800 + (index * 200)}>
                    <div className="accordion-header">
                      <h6
                        className={`accordion-title ${activeFaq === index ? 'active' : ''}`}
                        onClick={() => setActiveFaq(activeFaq === index ? -1 : index)}
                      >
                        {item.q}
                      </h6>
                    </div>
                    {activeFaq === index && (
                      <div className="accordion-collapse collapse show">
                        <div className="accordion-content"><p>{item.a}</p></div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;